
import React from 'react';
import AnimatedBackground from '@/components/landing/AnimatedBackground';
import HeroSection from '@/components/landing/HeroSection';
import FeaturesSection from '@/components/landing/FeaturesSection';
import CommunitySection from '@/components/landing/CommunitySection';
import CTASection from '@/components/landing/CTASection';
import Footer from '@/components/landing/Footer';

const Landing: React.FC = () => {
  return (
    <div className="min-h-screen overflow-hidden">
      {/* Background */}
      <AnimatedBackground />
      
      {/* Hero section */}
      <HeroSection />
      
      {/* Features section */}
      <FeaturesSection />
      
      {/* Community & Learning section */}
      <CommunitySection />
      
      {/* CTA section */}
      <CTASection />
      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Landing;
